import {
  SET_OPERATING_COSTS,
  ADD_OPERATING_COST,
  UPDATE_OPERATING_COST,
  REMOVE_OPERATING_COST,
} from 'appredux/actionTypes';
import {IFdOperatingCost} from 'constants/interfaces';

export type OperatingCostsState = {
  lastUpdate: number;
  rows: IFdOperatingCost[];
};

type Action = {
  type: string;
  payload: any;
};

const initialState: OperatingCostsState = {
  lastUpdate: 0,
  rows: [],
};

function reduxMergeOperatingCost(
  prev: IFdOperatingCost | undefined,
  incoming: IFdOperatingCost,
): IFdOperatingCost {
  const expense = incoming.expense ?? prev?.expense;
  const monthlyCosts = incoming.monthlyCosts ?? prev?.monthlyCosts;
  const notes = incoming.notes ?? prev?.notes;
  return {
    ...(prev ?? ({} as IFdOperatingCost)),
    ...incoming,
    expense,
    monthlyCosts,
    notes,
  };
}

export default function reduxOperatingCostsReducer(
  state: OperatingCostsState = initialState,
  action: Action,
): OperatingCostsState {
  switch (action.type) {
    case SET_OPERATING_COSTS: {
      const rows: IFdOperatingCost[] = action.payload || [];
      return {
        lastUpdate: Date.now(),
        rows: [...rows],
      };
    }
    case ADD_OPERATING_COST: {
      const added: IFdOperatingCost = action.payload;
      return {
        ...state,
        lastUpdate: Date.now(),
        rows: [...state.rows, added],
      };
    }
    case UPDATE_OPERATING_COST: {
      const updated: IFdOperatingCost = action.payload;
      const idx = state.rows.findIndex(
        (r) => String(r.id) === String(updated?.id),
      );

      if (idx >= 0) {
        const next = [...state.rows];
        next[idx] = reduxMergeOperatingCost(state.rows[idx], updated);
        return {...state, lastUpdate: Date.now(), rows: next};
      }

      return {
        ...state,
        lastUpdate: Date.now(),
        rows: [...state.rows, updated],
      };
    }
    case REMOVE_OPERATING_COST: {
      const idToRemove = action.payload;
      return {
        ...state,
        lastUpdate: Date.now(),
        rows: state.rows.filter((r) => String(r.id) !== String(idToRemove)),
      };
    }
    default:
      return state;
  }
}
